import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { State } from './types';

import { FilterBy, SortBy } from '@/studio/studioEventList/store/types';

export const getInitialState = () => ({
  filteredEvents: {},
  searchTerm: '',
  filterBy: FilterBy.UpcomingEvents,
  sortBy: SortBy.EventDateDescending,
  isLoading: false,
  currentPage: 1,
  eventsPerPage: 25,
  eventsCount: 0,
  currentEventId: '',
  currentEventType: '',
  isUpdateEventLoading: false,
  events: {},
  isFetchingEvents: false
});

const state: State = getInitialState();

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
